import React, {useContext, useEffect, useState} from "react";
import Api from "../../Api";
import {useParams} from "react-router-dom";
import {withAuth} from "../../hoc/Auth";
import {AddressDaData, InputHelper, MaskedIH, Select} from "../../Components/Utils/FieldsHelper";
import SingleDatePicker from "../../Components/Utils/SingleDatePicker";
import EmptyCard from "../../hoc/EmptyCard";
import Button from "../../Components/Utils/UI/Button";
import MessageContext from "../../MessageContext";

import classes from "./styles.module.css";

function PrepaidActivate({token}) {

    const EAN = useParams().EAN;
    const {onMessage} = useContext(MessageContext);
    const [form, setForm] = useState({
        docSerial: "",
        docNumber: "",
        docIssuer: "",
        docIssuedDate: "",
        docIssuerCode: "",
        secondName: "",
        firstName: "",
        patronymic: "",
        gender: null,
        birthday: "",
        birthPlace: "",
        birthCountry: "",
        codeWord: "",
        phone: "",
        inn: "",
        legalAddress: {value: ""},
        residenceAddress: {value: ""}
    });

    const [isRequest, setIsRequest] = useState(false);

    const genderList = [
        {displayName: 'Мужской', isEnabled: true, id: "0"},
        {displayName: 'Женский', isEnabled: true, id: "1"}
    ];

    const countryList = [
        {displayName: 'Россия', isEnabled: true, id: 'Россия'},
    ]

    useEffect(() => {
        setIsRequest(true);

        new Api({token}).getPreActivatedCardDetails(EAN).then(r => {

            if (r.activationData) {
                setForm({
                    ...r.activationData,
                    docIssuedDate: Date.parse(r.activationData.docIssuedDate),
                    birthday: Date.parse(r.activationData.birthday),
                    gender: genderList.find(val => val.id === r.activationData.gender),
                    birthCountry: countryList.find(val => val.id === r.activationData.birthCountry)
                });
            }

            setIsRequest(false);
        })
    }, [EAN])

    function handleChange(name, value) {
        setForm({...form, [name]: value});
    }

    function handleActivate() {

        setIsRequest(true);

        for (let key in form) {
            if (form[key] === null || form[key].length === 0) {
                onMessage({
                    type: 'warning',
                    message: 'Все поля обязательны к заполнению. Проверьте данные и повторите попытку.'
                });
                return setIsRequest(false);
            }
        }

        new Api({token}).setPreActivatedCardActivate(EAN, form).then(r => {
            if (!r.error && r.result === "success") {
                return onMessage({
                    type: 'success',
                    message: 'Карта проходить процесс активации. Отслеживать состояние можно в разделе "Детализация"'
                });
            } else {
                onMessage({
                    type: "error",
                    message: "Ошибка. В форме пристутствуют ошибки. Проверьте данные и попробуйте снова."
                })
                return setIsRequest(false);
            }
        })
    }

    return (
        <div className={`${classes.containerFluid} d-flex flex-column min-vh-100`}>
            <div className="row flex-grow-1">
                <div className="col-12 pt-2">
                    <EmptyCard title={"Prepaid.title.activate"} subtitle={`EAN: ${EAN}`}>

                        <div className={classes.Content}>
                            <div className={classes.Column}>

                                <h3 className={classes.Title}>Паспортные данные</h3>

                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            fieldName={"docSerial"}
                                            value={form.docSerial}
                                            label={"FieldsHelper.label.docSerial"}
                                            blurMessage={"FieldsHelper.error.docSerial"}
                                            placeholder={"00 00"}
                                            mask={[/\d/, /\d/, " ", /\d/, /\d/]}
                                            isDisabled={isRequest}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            fieldName={"docNumber"}
                                            value={form.docNumber}
                                            label={"FieldsHelper.label.docNumber"}
                                            blurMessage={"FieldsHelper.error.docNumber"}
                                            placeholder={"000000"}
                                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                            isDisabled={isRequest}
                                        />
                                    </div>
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.docIssuer}
                                        placeholder={"Например: Отделом внутренних дел Г. МОСКВЫ"}
                                        fieldName={"docIssuer"}
                                        label={"FieldsHelper.label.Issued"}
                                        changeRegexp={/[^А-Яа-я\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={isRequest}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>

                                        <label className={classes.Label}>Дата выдачи</label>

                                        <SingleDatePicker
                                            selected={form.docIssuedDate}
                                            onChange={date => {
                                                setForm({...form, docIssuedDate: date});
                                            }}
                                            className={classes.Input}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="00.00.0000"
                                            disabled={isRequest}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            value={form.docIssuerCode}
                                            fieldName={"docIssuerCode"}
                                            label={"FieldsHelper.label.departmentCode"}
                                            blurMessage={"FieldsHelper.error.docIssuerCode"}
                                            placeholder={"000-000"}
                                            mask={[/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
                                            isDisabled={isRequest}
                                        />
                                    </div>
                                </div>

                                <h3 className={classes.Title}>Личные данные</h3>

                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.secondName}
                                        placeholder={"Например: Курчатов"}
                                        fieldName={"secondName"}
                                        label={"FieldsHelper.label.lastName"}
                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                        changeMessage={"FieldsHelper.error.onlyLettersLastName"}
                                        blurMessage={"FieldsHelper.error.onlyLettersLastName"}
                                        isDisabled={isRequest}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.firstName}
                                        placeholder={"Например: Игорь"}
                                        fieldName={"firstName"}
                                        label={"FieldsHelper.label.firstName"}
                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                        changeMessage={"FieldsHelper.error.onlyLettersFirstName"}
                                        blurMessage={"FieldsHelper.error.onlyLettersFirstName"}
                                        isDisabled={isRequest}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.patronymic}
                                        placeholder={"Например: Васильевич"}
                                        fieldName={"patronymic"}
                                        label={"FieldsHelper.label.patronymic"}
                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                        changeMessage={"FieldsHelper.error.onlyLettersPatronymic"}
                                        blurMessage={"FieldsHelper.error.onlyLettersPatronymic"}
                                        isDisabled={isRequest}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <Select
                                            label={"FieldsHelper.label.gender"}
                                            placeholder={"FieldsHelper.placeholder.gender"}
                                            values={genderList}
                                            onChange={(value) => handleChange("gender", value)}
                                            selectedValue={form.gender}
                                            fieldName={"displayName"}
                                            fieldStatus={"isEnabled"}
                                            isLoading={isRequest}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата рождения</label>

                                        <SingleDatePicker
                                            selected={form.birthday}
                                            onChange={date => {
                                                setForm({...form, birthday: date});
                                            }}
                                            className={classes.Input}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="00.00.0000"
                                            disabled={isRequest}
                                        />
                                    </div>
                                </div>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={form.birthPlace}
                                            placeholder={""}
                                            fieldName={"birthPlace"}
                                            label={"FieldsHelper.label.birthPlace"}
                                            changeRegexp={/[^A-Za-zА-Яа-я\s".]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я\s".]/}
                                            changeMessage={"FieldsHelper.error.onlyLatinBirthPlace"}
                                            blurMessage={"FieldsHelper.error.checkBirthPlace"}
                                            isDisabled={isRequest}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <Select
                                            label={"FieldsHelper.label.birthCountry"}
                                            placeholder={"FieldsHelper.placeholder.birthCountry"}
                                            values={countryList}
                                            onChange={(value) => handleChange("birthCountry", value)}
                                            selectedValue={form.birthCountry}
                                            fieldName={"displayName"}
                                            fieldStatus={"isEnabled"}
                                            isLoading={isRequest}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={classes.Column}>

                                <h3 className={classes.Title}>Дополнительные данные</h3>

                                <p className={classes.Text}>Кодовое слово необходимо для обращения в банк.</p>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        onChange={handleChange}
                                        value={form.codeWord}
                                        placeholder={""}
                                        fieldName={"codeWord"}
                                        label={"FieldsHelper.label.codeWord"}
                                        changeRegexp={/[^A-Za-zА-Яа-я\s]+/g}
                                        blurRegexp={/([A-Z]+\s)+([A-Z]+)/ig}
                                        changeMessage={"FieldsHelper.error.onlyLatinCardholder"}
                                        blurMessage={"FieldsHelper.error.checkCardholderName"}
                                        isUppercase
                                        isDisabled={isRequest}
                                        autoComplete="off"
                                    />
                                </div>

                                <h3 className={classes.Title}>Контактная информация</h3>

                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <MaskedIH
                                            onChange={handleChange}
                                            value={form.phone}
                                            fieldName={"phone"}
                                            label={"FieldsHelper.label.phone"}
                                            changeMessage={"FieldsHelper.error.onlyNumbersPhone"}
                                            blurMessage={"FieldsHelper.error.checkPhone"}
                                            placeholder={"+7 (917) 574-4444"}
                                            mask={['+', '7', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                            isDisabled={isRequest}
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            onChange={handleChange}
                                            value={form.inn}
                                            fieldName={"inn"}
                                            label={"FieldsHelper.label.inn"}
                                            placeholder={"0000000000"}
                                            changeRegexp={/[^0-9]+/g}
                                            blurRegexp={/^[0-9]{12}/}
                                            changeMessage={"FieldsHelper.error.onlyNumbersInn"}
                                            blurMessage={"FieldsHelper.error.checkNumbersInn"}
                                            isDisabled={isRequest}
                                        />
                                    </div>
                                </div>

                                <div className={classes.InputWrap}>
                                    <AddressDaData
                                        onChange={handleChange}
                                        label={"FieldsHelper.label.legalAddress"}
                                        placeholder={"Начните вводить адрес"}
                                        value={form.legalAddress.value}
                                        fieldName={"legalAddress"}
                                        changeRegexp={/[^А-Яа-я0-9\s.,]+/g}
                                        blurRegexp={/^[А-Яа-я0-9\s.,]+$/g}
                                        changeMessage={"FieldsHelper.error.onlyLettersAddress"}
                                        isDisabled={isRequest}
                                    />
                                </div>

                                <div className={classes.InputWrap}>

                                    <AddressDaData
                                        onChange={handleChange}
                                        label={"FieldsHelper.label.residenceAddress"}
                                        placeholder={"Начните вводить адрес"}
                                        value={form.residenceAddress.value}
                                        fieldName={"residenceAddress"}
                                        changeRegexp={/[^А-Яа-я0-9\s.,]+/g}
                                        blurRegexp={/^[А-Яа-я0-9\s.,]+$/g}
                                        changeMessage={"FieldsHelper.error.onlyLettersAddress"}
                                        blurMessage={"FieldsHelper.error.onlyLettersAddress"}
                                        isDisabled={isRequest}
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <Button label={"Profile.btn.activate"} color={"#35C98E"} onClick={handleActivate}
                                            icon={"checkmark"} isLoading={isRequest}/>
                                </div>

                            </div>
                        </div>

                    </EmptyCard>
                </div>
            </div>
        </div>
    )
}

export default withAuth(PrepaidActivate);


// WEBPACK FOOTER //
// ./src/PagesOfUser/PrepaidActivate/index.jsx